<template>
    <div class="wl-container">
        <div class="updateGuide" v-if="updateGuide"></div>
        <NewComments :messageType="messageType" :siteId="siteId"></NewComments>
        <div class="wl-content-container content-with-comments">
            <div class="tab-box">

            
                <ul class="wl-tab">
                    <li v-if="getSite.hasInterim" :class="active === '1' ? 'active' : ''" @click="handleClick('1')">
                        {{ $t('COMMON_INTERIM') }}
                    </li>
                    <li :class="active === '2' ? 'active' : ''" @click="handleClick('2')">{{ $t('COMMON_FINAL') }}</li>
                </ul>
                <div class="top-right-btns">
                    <div :class="updateGuide && updateGuideStep === 2 ? 'updateGuideIcon' : ''">
                        <GuidanceTooltip
                            class="downloadpbc-tip"
                            :content="topTipContent()"
                            :size="20"
                            :iconSize="15"
                            :jumpLink="$t(`downloadPBCTip_${getUser.userType}`)"
                        ></GuidanceTooltip>
                        <div class="updateGuideTip" v-if="updateGuide && updateGuideStep === 2">
                            <div class="margin-bottom-10">2/2</div>
                            <div class="margin-bottom-10">{{ $t('guidanceTip') }}</div>
                            <el-button @click="gotItClick" class="guide-btn">{{ $t('gotIt') }}</el-button>
                        </div>
                    </div>
                    <div class="split"></div>
                    <TableColumnsControl class="table-column-config" tableName="pbc" :onColumnsLoad="onColumnsLoad" :anyHidden.sync="anyHidden">
                        <div :class="['column-btn', anyHidden ? 'column-btn-active' : '']">
                            <img src="@/assets/img/icon-table-setting.svg" width="100%" class="table-setting-icon" />
                            <span class="table-setting-text">{{ $t('table_columns_display_btn') }}</span>
                        </div>
                    </TableColumnsControl>
                    <div class="split"></div>
                    <div :class="['clean-filter', clearAllActive ? 'clean-filter-active' : '']" @click="clearAll">
                        <img src="@/assets/img/icon-screen.svg" class="table-setting-icon" />
                        {{ $t('clear_filter') }}
                    </div>
                </div>
            </div>

            <!-- 除了筛选条件之外的一排按钮，如果要居右，在按钮的class 里加 right。居右的左右顺序跟代码顺序是相反的 -->
            <el-row class="search-btn-row">
                <!-- 左边的按钮 -->
                <!-- 批量下载 -->
                <el-button
                    class="wl-green"
                    @click="onToogleDownLoad('download')"
                    :disabled="tableStatus.editable || !hasPermission('download')"
                    icon="el-icon-download"
                    >{{ $t('BATCH_DOWNLOAD') }}
			<GuidanceTooltip
			  backgroundColor="none"
              yellowIcon
              :size="20"
              :iconSize="14"
              :content="$t('setFileAndDownloadTipHtml')"
              :jumpLink="$t('setFileAndDownloadTipLink')"
      
          ></GuidanceTooltip>
                    </el-button
                >
                <!-- 批量更新状态 -->
                <el-button v-if="getUser.userType == '1'"
                        class="wl-green"
                        style="position: relative; top: 2PX;"
                        @click="onToogleStatus"
                        :disabled="tableStatus.editable">
                    <img src="@/assets/img/icon-batchsetting.svg" width="100%" class="btn-icon" />
                    {{ $t('COMMON_SET_STATUS') }}
                </el-button>

                <!-- 右边的按钮，依次是从右到左 -->
                <!-- 导出文件记录 -->
                <el-button
                    class="wl-green right"
                    @click="onToogleDownLoad('export')"
                    :disabled="tableStatus.editable || !hasPermission('download')"
                    ><img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon" />{{ $t('BATCH_export') }}</el-button
                >

                <!-- 导出 pbc 条目，不知道为啥写两遍 -->
                <el-button
                    v-if="getUser.userType == '1'"
                    :disabled="!hasPermission('download')"
                    @click="sysCheckExportNum"
                    class="wl-green right"
                    ><img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon" />{{ $t('Export_PBC_Items') }}</el-button
                >
                <el-button v-if="getUser.userType == '2'" @click="clientCheckExportNum" class="wl-green right"
                    ><img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon" />{{ $t('Export_PBC_Items') }}</el-button
                >
                <!-- 发送提醒邮件 -->
                <el-button
                    class="wl-green right"
                    v-if="getUser.userType == '1'"
                    @click="onToogleSendEmail"
                    :disabled="tableStatus.editable"
                    icon="el-icon-message"
                >
                    {{ $t('PAGE_CLIENTUSER_EMAIL_PBC') }}
                    <!-- <GuidanceTooltip
                        :content="$t('sendNotifyEmailTipHtml')"
                        backgroundColor="none"
                        yellowIcon
                        :size="20"
                        :iconSize="14"
                        :jumpLink="$t('sendNotifyEmailLink')"
                    ></GuidanceTooltip> -->
                </el-button>
                <!-- 延用自中期 -->
                <el-button
                    v-if="active == '2' && getSite.hasInterim && getUser.userType == '1'"
                    class="wl-green right"
                    @click="onToogleCopy"
                    :disabled="tableStatus.editable"
                    ><img src="@/assets/img/icon-batchsetting.svg" width="100%" class="btn-icon" />{{
                        $t('COMMON_COPY_INTERIM')
                    }}</el-button
                >
                <!--v-if="getUser.userType=='1'"-->
                <!-- 客户应提供的资料清单 -->
                <!-- <el-tooltip class="item" effect="dark" placement="bottom"> -->
                <span class="right">
                        <el-button
                            v-if="getUser.userType == '1'"
                            @click="goTo"
                            class="wl-green margin"
                            :disabled="!(kpRoleBind && kpRoleBind.length > 0)"
                            ><img src="@/assets/img/icon-batchsetting.svg" width="100%" class="btn-icon" />{{
                                $t('COMMON_PBC_LIST')
                            }}
                            <GuidanceTooltip
                                :content="$t('setPbcListHtml')"
                                backgroundColor="none"
                                yellowIcon
                                :size="20"
                                :iconSize="14"
                                :jumpLink="$t('setPbcListHtmlLink')"
                            ></GuidanceTooltip>
                            </el-button
                        >
                </span>
                <!-- </el-tooltip> -->
            </el-row>
            <!-- 表格 -->
            <pbc-table
                :class="['wl-pbc-table', showSearchParams ? (screenWidth < 1920 ? 'show-search-rows4' : 'show-search') : '']"
                ref="pbcTable"
                :loading="loading"
                :downloading="fileDownloading"
                :tableStatus="tableStatus"
                :data="tableData"
                :kpmgOwnerList="kpmgOwnerList"
                @selectKPOwner="selectKPOwner"
                :clientOwnerList="clientOwnerList"
                @selectClientOwner="selectClientOwner"
                :dataPBC="dataPBC"
                :statusList="statusList"
                :topicList="topicList"
                :pagination="pagination"
                :onCancel="btnCancel"
                :onCancelInterim="updateTableStatusInterim"
                :onChange="switchStatus"
                :onPaginationChange="onPaginationChange"
                :onChangeStatusPopShow="openChangeVisiblePop"
                :onDownLoad="downloadPBC"
                :onUploadFileAfter="getTableData"
                :onCopy="copyFromInterim"
                :sourceTypes="sourceTypes"
                :applyFlags="applyFlags"
                :onChangeRow="onChangeRow"
                :downloadAble="downloadAble"
                :curUserName="curUserName"
                :siteId="siteId"
                @on-dueday-change="onDuedayChange"
                @on-charge-user-change="onChargeUserChange"
                @on-confirm-day-change="onConfirmDayChange"
                :showColumns="showColumns"
                :serialNo.sync="serialNo"
                :entityIds.sync="getEntityIds"
                :topic.sync="topic"
                :topicDesList="topicDesList"
                :topicDes.sync="topicDes"
                :createDate.sync="createDate"
                :dueTime.sync="dueTime"
                :sourceOfInfo.sync="sourceOfInfo"
                :applyFlagInfo.sync="applyFlagInfo"
                :filterStatusList="filterStatusList"
                :status.sync="status"
                :dayOverDue.sync="dayOverDue"
                :daysUntilDue.sync="daysUntilDue"
                :uploadTime.sync="uploadTime"
                :periodEndDate.sync="periodEndDate"
                :commentDate.sync="commentDate"
                :fileName.sync="fileName"
                :clientResponsible.sync="clientResponsible"
                :kpmgResponsible.sync="kpmgResponsible"
                :updateGuide="updateGuide"
                :updateGuideStep="updateGuideStep"
                @nextClick="nextClick"
                @openEntity="openEntity"
                :lastedUploadUserAccount.sync="lastedUploadUserAccount"
                :screenWidth="screenWidth"
                :clientConfirmDate.sync="clientConfirmDate"
                :messageType="messageType" 
            />

            <!-- 批量改状态 -->
            <batch-update
                v-if="batchUPdateVisible"
                :onCancel="toogleBatchUPdateVisible"
                :chosenList="chosen"
                :statusList="statusList"
                :onBatchUpdate="batchUpdate"
            ></batch-update>
        </div>
        <entity ref="entity" :onAdd="onDrawClick" :entityData="entityData" />

        <dashboard
            ref="dashboard"
            :dashboardData="dashboardData"
            :disabled="loading"
            :dashboardLoading="dashboardLoading"
            :dashboardTableLoading="dashboardTableLoading"
            @getDashboardData="getDashboardData"
            @chooseState="chooseState"
            @chooseTab="getPbcDrawerTable"
        />
        <RsDashboard
            ref="rsDashboard"
            :disabled="loading"
            :rsDashboardLoading="rsDashboardLoading"
            :data="rsDashboardData"
            :dashboardTableLoading="dashboardTableLoading"
            :chooseTabProp="getPbcDrawerTableData"
            :makeLevel3Data="tableDataToLevel3"
            :onCardClick="onRsDashboardCardClick"
            @chooseTab="getPbcDrawerTable"
            @getDashboardData="getDashboardData"
        ></RsDashboard>

        <form id="abc" method="post" action="/client/pbcGroup/downloadPbcFiles" onsubmit="return false" style="display: none">
            <input type="hidden" name="id" value="194226009606721540" />
            <input type="hidden" name="fileName" value="longhu.zip" />
        </form>
        <file-confirm-modal
            :fileDownloading="fileDownloading"
            ref="FileConfirmModal"
            :groupList="selectedRow"
            :downloadAble="downloadAble"
            :curUserName="curUserName"
            :mode="downloadDialogMode"
            @ok="downloadMultipleFiles"
            @fileDownload="downloadPBCListSingle"
            @getPbcList="getTableData"
        />
    </div>
</template>
<script>
import _ from 'lodash'
import API from '@/api'
import SelectMulti from '@/components/common/SelectMulti'
import PbcTable from './pbc-table'
import FileConfirmModal from './file-confirm-modal'
import BatchUpdate from './batch-update'
import requestUrl from '@/api/requestUrl'
import { loading, isIE, dateFormat, formatFileSize, arraysEqual } from '@/utils'
import { mapGetters } from 'vuex'
import Entity from '@/components/common/entity'
import dashboard from './dashboard'
import { userEntity } from '@/mixins/getUserEntity.js'
import { exportCsv, exportFileLogXls } from '@/utils/exportTable'
import RsDashboard from './RsDashboard.vue'
import TableColumnsControl from '@/components/common/TableColumnsControl'
import { userPermission } from '@/mixins/userPermission.js'
import GuidanceTooltip from '@/components/common/GuidanceTooltip.vue'
import { downloadSingleFile, downloadBatchFiles, downloadFileByUrl } from '@/utils/useDownload'
import { treeToList } from '@/utils/formatTree'
import windowConfig from '@/utils/windowConfig'
import NewComments from '@/components/common/NewComments.vue'

export default {
    data() {
        return {
            screenWidth: document.body.clientWidth, // 实时的屏幕宽度，处理因为查询条件显示3行/4行而挤压的表格高度
            queryParams: {
                interim: {
                    status: [],
                    dayOverDue: ['', ''], //逾期
                    daysUntilDue: ['', ''], //到期
                    topic: [],
                    topicDes: [],
                    uploadTime: [], //上传时间
                    dueTime: [], //截止时间
                    createDate: [], // 创建时间
                    sourceOfInfo: [],
                    applyFlagInfo: [],
                    kpmgResponsible: [],
                    clientResponsible: [],
                    commentDate:[],
                },
                final: {
                    status: [],
                    dayOverDue: ['', ''], //逾期
                    daysUntilDue: ['', ''], //到期
                    topic: [],
                    topicDes: [],
                    uploadTime: [], //上传时间
                    dueTime: [], //截止时间}
                    sourceOfInfo: [],
                    applyFlagInfo: [],
                    kpmgResponsible: [],
                    clientResponsible: [],
                    commentDate:[],
                    entityId: [],
                },
                pageSize: 10,
                entityId: []
            },
            submitted_before_deadline_pbc_request: false,
            overdued_pbc_count: false,
            // siteId: '',
            active: '2',
            status: [],
            dayOverDue: ['', ''],
            daysUntilDue: ['', ''],
            sourceOfInfo: [],
            applyFlagInfo: [],
            kpmgResponsible: [],
            clientResponsible: [],
            cacheSourceOfInfo: [],
            // source Of Information selector value
            sourceTypes: [],
            applyFlags: [],
            topic: [],
            cachedTopic: [],
            uploadTime: [],
            dueTime: [],
            periodEndDate: [],
            commentDate:[],
            createDate: [],
            tableData: [],
            tableStatus: {
                editable: false,
                mode: 'setStatus' //setStatus | download |copy | sendEmail
            },
            statusList: [],
            // topicList: [],
            topicListFilterText: '',
            baseTopicList: [],
            filterTextTimer: null,
            topicDes: [],
            cacheTopicDes: [],
            topicDesFilterText: '',
            filterDesTextTimer: null,
            loading: true,
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            chosen: [],
            batchUPdateVisible: false,
            dataPBC: [],
            fileDownloading: false,
            kpmgOwnerList: [],
            clientOwnerList: [],
            selectedRow: [],
            dashboardData: {
                pieData: {},
                tableData: [],
                tableData2: []
            },
            dashboardLoading: false,
            rsDashboardLoading: false,
            dashboardTableLoading: true,
            downloadAble: false,
            curUserName: '',
            kpRoleBind: [], //当前kp人员有无绑定角色信息
            disabledEntityIds: [], //用来记录原来有权限并且选中了,之后无权限的entityId
            showSearchParams: false,
            hideSearch: false,
            downloadDialogMode: '', // download | export
            rsDashboard: {
                disabled: true,
                show: false
            },
            showColumns: [],
            anyHidden: false,
            fileName: '',
            serialNo: '',
            updateGuide: false,
            updateGuideStep: 0,
            lastedUploadUserAccount: [],
            pbcDownloadConfig: 0,
            clientConfirmDate: ['', ''],
        }
    },
    mixins: [userEntity, userPermission],
    async created() {
        await this.getBehavior()
        if (this.$route.query.siteId) {
            API.businessHome.querySite({ siteIds: this.$route.query.siteId }).then((res) => {
                if (res.code == '1') {
                    this.$store.commit('common/setSite', res.data.records[0])
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        }
        if(this.$route.query.active){
            this.active = this.$route.query.active
        }else{
            this.active = this.getSite.hasInterim ? '1' : '2'
        }
        
        // this.siteId = this.$route.query.siteId ? this.$route.query.siteId : this.getSite.siteId
        if (this.getUser.userType === '1') {
            await this.getKpRolesBind()
        }
        await this.initMountedFunc();
        await this.getQueryParam()
        await this.getUserEntity('14')
        await this.showParams()
        if (this.$route.query.homeFilterStatus){
            this.$refs.pbcTable.resetNotStatus(this.allEntityIds)
            
            this.status= [this.$route.query.homeFilterStatus]

            this.$nextTick(async () => {
                await this.searchData(true)
            })
        } else {
            await this.searchData()
        }
        
        await this.queryLimits()
        await this.queryFileSizeLimits()


        window.onresize = () => {
            this.$refs['pbcTable'].changeGuideTitleHeight()
            return (this.screenWidth = document.body.clientWidth)
        }
        window.showClientVideo = () => this.showClientVideo()
        //默认展示dashboard页面
        if (this.$route.query.openDashboard == '1'){
            this.$refs.dashboard.openDraw();
        }
    },
    prevParams: {},
    methods: {
        initMountedFunc() {
            return Promise.all([
                this.queryPbcSourceTypeAndStatus(),
                this.queryTopicList()
            ]);
        },
        /**
         * 顶部的黄色问号
         * kp端跳视频，client端弹视频
         */
        showClientVideo() {
            this.$showVideoDialog()
            localStorage.setItem('homepage_video_close_all', 1)
            this.$nextTick(() => {
                this.$chooseVideo(3, true)
            })
        },
        topTipContent() {
            if (this.getUser.userType == '1') {
                return this.$t('downloadPBCTipHtmlKp')
            } else {
                return this.$t('downloadPBCTipHtmlKp')
            }
        },
        /**
         * rs dashboard 卡片点击事件
         *
         * @param cardNum 被点击的卡片号，例如level2的第三个就是23
         * @param revert 正常都是点选，这个是反选，如果是 true，就把目标的条件给去掉或者是变为 false
         */
        onRsDashboardCardClick(cardNum, revert = false) {
            if (!['02', '11', '12', '21', '22'].includes(cardNum)) return

            // 先初始化和dashboard相关的条件
            this.daysUntilDue = ['', '']
            this.dayOverDue = ['', '']
            this.status = []
            this.submitted_before_deadline_pbc_request = false
            this.overdued_pbc_count = false

            switch (cardNum) {
                case '02':
                    {
                        this.daysUntilDue = ['0', '99999']
                        this.dayOverDue = ['0', '99999']
                        this.status = ['3', '5', '6']
                    }
                    break
                case '11':
                    {
                        this.status = ['2']
                    }
                    break
                case '12':
                    {
                        this.status = ['4']
                    }
                    break
                // case '21': {
                //     this.submitted_before_deadline_pbc_request = !revert
                // } break
                // case '22': {
                //     this.overdued_pbc_count = !revert
                // } break
            }

            this.$refs.rsDashboard.hide()
            this.searchData()
        },
        onColumnsLoad(columns) {
            this.showColumns = columns
        },
        onSearchCollapseChange(e) {
            this.showSearchParams = e.length > 0
        },
        getKpRolesBind() {
            const params = {
                siteId: this.getSite.siteId
            }
            API.kpTMember.checkLoginUserHasRoles(this.getSite.siteId).then((res) => {
                if (res.code === '1') {
                    this.kpRoleBind = res.data
                }
            })
        },
        searchBtnClick() {
            this.pagination.pageNum = 1
            this.$refs.pbcTable.initStartIndex()
            this.searchData()
        },

        // 打开弹窗获取Echart数据/表格数据
        async getDashboardData (loadingType, callbck) {
            this[loadingType] = true
            Promise.all([this.getPieEcharts(), this.getPbcDrawerTable()]).then(res => {
                this[loadingType] = false
                callbck(true)
            })
        },
        async searchData(isHomeFilterStatus) {
            await this.getTableData(isHomeFilterStatus)

        },
        // 查询文件下载大小限制
        async queryFileSizeLimits() {
            const res = await API.general.siteTilesGeneral({ siteId: this.getSite.siteId })
            if (res.code === '1') {
                this.pbcDownloadConfig = Number(res.data.pbcDownloadConfig)
            }
        },
        // 查询当前站点downloadable
        async queryLimits() {
            const { code, data } = await API.clientUser.getSiteConfig({ param: this.getSite.siteId })
            if (code == '1') {
                this.downloadAble = !!data.downloadable
            } else {
                this.$message.error(this.$t(code))
            }
            // 当前文件uploadby
            let userType = this.getUser.userType
            if (userType == '1') {
                this.curUserName = this.getUser.userName
            } else {
                this.curUserName = this.getUser.userAccount
            }
        },
        // 获取缓存的查询条件
        async getQueryParam() {
            const params = localStorage.getItem(this.getUser.userId + '' + this.getSite.siteId)
            if (params) {
                this.queryParams = JSON.parse(params)
            } else {
                const { code, data } = await API.pbc.getQueryCondition({ siteId: this.getSite.siteId })
                 
                if (code === '1') {
                    if (data.queryCondition != null && data.queryCondition != '') {
                        this.queryParams = JSON.parse(data.queryCondition)
                    } else {
                         
                        const paramsDefault = `{"interim":{"status":[],"dayOverDue":[],"daysUntilDue":[],"topic":[],"topicDes":[],"uploadTime":[],"dueTime":[],"periodEndDate":[],"commentDate":[],"topicIdList":[],"sourceOfInfo":[],"applyFlagInfo":[],"kpmgResponsible":[],"clientResponsible":[],"createDate":[],"serialNo":"","fileName":"","lastedUploadUserAccount":[],"clientConfirmDate":[]},"final":{"status":[],"dayOverDue":[],"daysUntilDue":[],"topic":[],"topicDes":[],"uploadTime":[],"dueTime":[],"periodEndDate":[],"commentDate":[],"topicIdList":[],"sourceOfInfo":[],"applyFlagInfo":[],"kpmgResponsible":[],"clientResponsible":[],"createDate":[],"serialNo":"","fileName":"","lastedUploadUserAccount":[],"clientConfirmDate":[],"entityId":[]},"pageSize":10,"entityId":[],"siteId":"${this.getSite.siteId}"}`
                        this.queryParams = JSON.parse(paramsDefault)
                    }
                } else {
                    this.$message.error(this.$t(code))
                }
            }

             
        },
        // 显示设置查询条件
        showParams() {
            if (this.active == '1') {
                this.status = this.queryParams.interim.status
                this.dayOverDue = this.queryParams.interim.dayOverDue
                this.daysUntilDue = this.queryParams.interim.daysUntilDue
                this.topic = this.queryParams.interim.topic || []
                this.topicDes = this.queryParams.interim.topicDes || []
                this.uploadTime = this.queryParams.interim.uploadTime
                this.dueTime = this.queryParams.interim.dueTime
                this.periodEndDate = this.queryParams.interim.periodEndDate
                this.commentDate = this.queryParams.interim.commentDate
                this.topic = this.queryParams.interim.topicIdList
                this.sourceOfInfo = this.queryParams.interim.sourceOfInfo
                this.applyFlagInfo = this.queryParams.interim.applyFlagInfo || []
                this.kpmgResponsible = this.queryParams.interim.kpmgResponsible || []
                this.clientResponsible = this.queryParams.interim.clientResponsible || []
                this.createDate = this.queryParams.interim.createDate
                this.serialNo = this.queryParams.interim.serialNo
                this.fileName = this.queryParams.interim.fileName
                this.clientConfirmDate = this.queryParams.interim.clientConfirmDate
                this.lastedUploadUserAccount = this.queryParams.interim.lastedUploadUserAccount
            } else {
                this.status = this.queryParams.final.status
                this.dayOverDue = this.queryParams.final.dayOverDue
                this.daysUntilDue = this.queryParams.final.daysUntilDue
                this.topic = this.queryParams.final.topic || []
                this.topicDes = this.queryParams.final.topicDes || []
                this.uploadTime = this.queryParams.final.uploadTime
                this.dueTime = this.queryParams.final.dueTime
                this.periodEndDate = this.queryParams.final.periodEndDate
                this.commentDate = this.queryParams.final.commentDate
                this.topic = this.queryParams.final.topicIdList
                this.sourceOfInfo = this.queryParams.final.sourceOfInfo
                this.applyFlagInfo = this.queryParams.final.applyFlagInfo || []
                this.kpmgResponsible = this.queryParams.final.kpmgResponsible || []
                this.clientResponsible = this.queryParams.final.clientResponsible || []
                this.createDate = this.queryParams.final.createDate
                this.serialNo = this.queryParams.final.serialNo
                this.fileName = this.queryParams.final.fileName
                this.clientConfirmDate = this.queryParams.final.clientConfirmDate
                this.lastedUploadUserAccount = this.queryParams.final.lastedUploadUserAccount
                this.entityId = this.queryParams.final.entityId || []
            }
            

            //从主页跳过来默认筛选选中的状态
            // if (this.$route.query.homeFilterStatus){
            //     this.status= [this.$route.query.homeFilterStatus]
            // }
            this.pagination.pageSize = this.queryParams.pageSize || 10
            if (this.queryParams.entityId && this.queryParams.entityId.length > 0) {
                this.disabledEntityIds = []
                this.handleTreeCheck(this.entityData[0], this.queryParams.entityId)
                // 当前用户权限下的allEntityIds 反向筛选 记录的entityId(权限变小，如之前有entityA的权限并选中查询，权限改变后没有entityA的权限)
                const curEntityId = this.queryParams.entityId.filter((item) => this.allEntityIds.indexOf(item) !== -1)
                if (this.disabledEntityIds.length > 0) {
                    let entityIds = curEntityId.filter((item) => this.disabledEntityIds.indexOf(item) === -1)
                    this.$store.commit('common/setEntityIds', entityIds)
                } else {
                    this.$store.commit('common/setEntityIds', curEntityId)
                }
            }
        },
        // 记录的查询条件中存在的entityId默认选上，并记录entityId中现在被禁用的entityId,供之后过滤
        handleTreeCheck(data, entityIds) {
            if (!data.disabled) {
                if (entityIds.indexOf(data.id) !== -1) {
                    data.checked = true
                } else {
                    data.checked = false
                }
            } else {
                data.checked = false
                entityIds.indexOf(data.id) !== -1 ? this.disabledEntityIds.push(data.id) : ''
            }
            if (data.childEntity && data.childEntity.length > 0) {
                data.childEntity.forEach((item) => this.handleTreeCheck(item, entityIds))
            }
        },
        // 一键清除
        clearAll() {
            // this.status = []
            // this.dayOverDue = ['', '']
            // this.daysUntilDue = ['', '']
            // this.topic = []
            // this.topicDes = []
            // this.uploadTime = []
            // this.dueTime = []
            // this.periodEndDate = []
            // this.sourceOfInfo = []
            // this.$store.commit('common/setEntityIds', this.allEntityIds)
            // this.kpmgResponsible = []
            // this.clientResponsible = []
            // this.createDate = []
            // this.submitted_before_deadline_pbc_request = false
            // this.overdued_pbc_count = false
            // this.fileName = ''
            // this.serialNo = ''
            this.$refs.pbcTable.cleanFilter(this.allEntityIds)
            this.$nextTick(() => {
                // this.getPieEcharts()
                // this.getPbcDrawerTable()
                // this.$refs.rsDashboard.resetTab()
            })
            // this.searchData()
        },
        // 记录查询条件
        async setQueryParam() {
            const params = {
                status: this.status,
                dayOverDue: this.dayOverDue,
                daysUntilDue: this.daysUntilDue,
                topic: this.topic,
                topicDes: this.topicDes,
                uploadTime: this.uploadTime,
                dueTime: this.dueTime,
                periodEndDate: this.periodEndDate,
                topicIdList: this.topic,
                sourceOfInfo: this.sourceOfInfo,
                applyFlagInfo: this.applyFlagInfo,
                kpmgResponsible: this.kpmgResponsible,
                clientResponsible: this.clientResponsible,
                createDate: this.createDate,
                commentDate: this.commentDate,
                serialNo: this.serialNo,
                fileName: this.fileName,
                lastedUploadUserAccount: this.lastedUploadUserAccount,
                clientConfirmDate: this.clientConfirmDate
            }
            let temp = JSON.parse(localStorage.getItem(this.getUser.userId + '' + this.getSite.siteId)) || this.queryParams
            if (this.active == '1') {
                temp.interim = params
            } else {
                temp.final = params
            }
            temp.pageSize = this.pagination.pageSize
            temp.entityId = this.getEntityIds
            temp.siteId = this.getSite.siteId
            // 存放本地缓存
             
            localStorage.setItem(this.getUser.userId + '' + this.getSite.siteId, JSON.stringify(temp))
            // 存放数据库
            try {
                const { data, code } = await API.pbc.setQuery({ ...temp, userId: this.getUser.userId, userType: this.getUser.userType })
                if (code !== '1') {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
            }
        },
        onDrawClick() {
            this.pagination.pageNum = 1
            this.getTableData()
            // this.getPieEcharts()
            // this.getPbcDrawerTable()
        },
        filterTopic(text) {
            if (this.filterTextTimer) clearTimeout(this.filterTextTimer)
            this.filterTextTimer = setTimeout(() => {
                this.topicListFilterText = text
            }, 400)
        },
        // 已识别的相关数据要素
        filterTopicDes(text) {
            if (this.filterDesTextTimer) clearTimeout(this.filterDesTextTimer)
            this.filterDesTextTimer = setTimeout(() => {
                this.topicDesFilterText = text
            }, 400)
        },
        goTo() {
            this.$router.push({ path: '/new-pbc-list', query: { audit: this.active } })
        },
        async handleClick(val) {
            this.active = val
            const $finalTableInstance = this.$refs.pbcTable.$children[0]
            if ($finalTableInstance.expand) $finalTableInstance.expandAll()
            await this.queryTopicList()
            await this.getQueryParam()
            await this.showParams()
            this.pagination.pageNum = 1
            this.searchData()
        },
        checkNeedUpdateTable(key) {
            if (this.prevParams[key] !== this[key]) {
                this.changeFilter()
            }
        },
        topicListVisibleChange(visible) {
            if (visible) {
                this.cachedTopic = this.topic
            } else {
                if (arraysEqual(this.cachedTopic, this.topic)) return
                this.topicListFilterText = ''
                this.changeFilter()
            }
        },
        topicListChange(val) {
            if (val.includes('select_all')) {
                this.topic = this.topic
                    .concat(this.topicList.slice(1, this.topicList.length).map((item) => item.topicId))
                    .filter((t) => t != 'select_all')
                this.topic = this.unique(this.topic)
            }
            this.topicDes = []
        },
        unique(arr) {
            return Array.from(new Set(arr))
        },
        // 已识别的相关数据要素
        topicDesVisibleChange(visible) {
            if (visible) {
                this.cachedTopicDes = this.topicDes
            } else {
                if (arraysEqual(this.cachedTopicDes, this.topicDes)) return
                this.topicDesFilterText = ''
                this.changeFilter()
            }
        },
        topicDesChange(val) {
            if (val.includes('select_all')) {
                this.topicDes = this.topicDes
                    .concat(this.topicDesList.slice(1, this.topicDesList.length).map((item) => item.topicId))
                    .filter((t) => t != 'select_all')
                this.topicDes = this.unique(this.topicDes)
            }
        },
        sourceOfInfotVisibleChange(visible) {
            if (visible) {
                this.cacheSourceOfInfo = this.sourceOfInfo
            } else {
                if (arraysEqual(this.cacheSourceOfInfo, this.sourceOfInfo)) return
                // this.changeSourceFilter();
            }
        },
        changeFilter() {
            // this.sourceOfInfo = []
            // this.clientResponsible = ''
            // this.kpmgResponsible = ''
            // this.pagination.pageNum = 1
        },
        changeSourceFilter() {
            this.status = []
            this.topic = []
            this.topicDes = []
            this.dayOverDue = ['', '']
            this.daysUntilDue = ['', '']
            this.uploadTime = []
            this.dueTime = []
            this.periodEndDate = []
            this.clientResponsible = ''
            this.kpmgResponsible = ''
            this.createDate = []
            this.commentDate = []
            this.pagination.pageNum = 1
        },
        //status, sourceType 列表
        async queryPbcSourceTypeAndStatus() {
            try {
                const { data, code } = await API.pbc.queryPbcSourceTypeAndStatus()

                if (code == '1') {
                    this.statusList = data.status || []
                    this.sourceTypes = data.sourceType || []
                    this.sourceTypes.map((item) => {
                        if (item.internationalStatus === 'Blank') {
                            item.internationalStatus = this.$t('common_empty')
                        }
                    })
                    this.applyFlags = data.applyFlag || []
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
            }
        },
        //topic下拉
        async queryTopicList() {
            try {
                const { data, code } = await API.pbc.getTopicList({ siteId: this.siteId, auditType: this.active })
                if (code == '1') {
                    // this.topicList = data
                    this.baseTopicList = data.filter((v) => v.topicId != 'Blank')
                    this.topic = []
                    /* this.topicList.forEach((i, n) => {
                             this.topic.push(i.topicId)
                         })*/
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
            }
        },
        //表格查询, isHomeFilterStatus表示从外面快捷卡片进入，此时初始化时不需保存查询参数
        async getTableData(isHomeFilterStatus = false) {
            if (!this.getIfKpHasAccess) {
                this.loading = false
                return
            }
            try {
                this.loading = true
                const params = this.getRequestParams()
                if (!isHomeFilterStatus) {
                    this.setQueryParam()
                } else if (isHomeFilterStatus) {
                    //从外层卡片点进来 不查不适用的数据
                    this.applyFlagInfo = ['0']
                    params.applyFlagInfo = this.applyFlagInfo
                }
                params.lang = this.$i18n.locale
                let res = null
                // if((params.sourceOfInfo && params.sourceOfInfo.length > 0) || params.kpmgInCharge != '' || params.clientInCharge != ''){
                // res = await API.pbc.queryPbcOfSourceOrResponsibleUser(params)
                // } else {
                res = await API.pbc.getFinalData(params)
                // }
                if (res.code == '1') {
                    this.tableData = res.data.records == null ? [] : res.data.records
                    this.pagination.total = res.data.total
                    this.loading = false
                } else {
                    this.$message.error(this.$t(res.code))
                }
            } catch (e) {
            } finally {
                this.loading = false
            }
        },
        // 点击饼图更新state重新查询
        chooseState(data) {
             
            switch (data.name) {
                case '即将到期':
                case 'Upcoming due':
                    this.status = ['5']
                    break

                case '已逾期':
                case 'Overdue':
                    this.status = ['6']
                    break

                case '已上传':
                case 'Uploaded':
                    this.status = ['2']
                    break

                case '需修订':
                case 'Revision Required':
                    this.status = ['3']
                    break

                case '已接受':
                case 'Accepted':
                    this.status = ['4']
                    break
            }
            this.sourceOfInfo = []
            this.getTableData(true)
            // this.getPieEcharts()
            // this.getPbcDrawerTable()
        },
        async getPbcDrawerTableData(name) {
            const params = this.getRequestParams()
            params.target = name && name != '' ? name : 'entity'
            if ((params.sourceOfInfo && params.sourceOfInfo.length > 0) || params.kpmgInCharge != '' || params.clientInCharge != '') {
                params.ifSourceInformation = true
            } else {
                params.ifSourceInformation = false
            }

            // const topicIdList = params.topicIdList
            // delete params['topicIdList']
            // params.pidList = topicIdList
            let tableData = []
            let tableData2 = []
            try {
                let { code, data } = await API.pbc.getDashTable(params)
                if (code == '1') {
                    if (data.length > 0) {
                        data.forEach((item) => {
                            item.total = item.accepted + item.due + item.overdue + item.revisionRequired + item.uploaded
                        })
                        tableData = data.map((v) => {
                            if (v.target == 'blank') {
                                v.target = this.$t('no_assign')
                            }
                            return v
                        })
                        let data2 = []
                        data.forEach((item) => {
                            let temp = {}
                            temp.target = item.target
                            temp.accepted = item.total == 0 ? '0%' : Math.round((item.accepted * 100) / item.total) + '%'
                            temp.due = item.total == 0 ? '0%' : Math.round((item.due * 100) / item.total) + '%'
                            temp.overdue = item.total == 0 ? '0%' : Math.round((item.overdue * 100) / item.total) + '%'
                            temp.revisionRequired = item.total == 0 ? '0%' : Math.round((item.revisionRequired * 100) / item.total) + '%'
                            temp.uploaded = item.total == 0 ? '0%' : Math.round((item.uploaded * 100) / item.total) + '%'
                            temp.total = item.total
                            data2.push(temp)
                        })
                        tableData2 = data2
                    }

                    return { tableData, tableData2 }
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
                this.dashboardTableLoading = false
            }
        },
        // 选择维度表格--更新维度
        async getPbcDrawerTable(name) {
            this.dashboardTableLoading = true
            this.dashboardData.tableData = []
            this.dashboardData.tableData2 = []
            const { tableData, tableData2 } = await this.getPbcDrawerTableData(name)
            this.dashboardData.tableData = tableData
            this.dashboardData.tableData2 = tableData2
        },
        // 查询图标---饼图信息
        async getPieEcharts() {
            try {
                
                const params = this.getRequestParams()
                // const topicIdList = params.topicIdList
                // delete params['topicIdList']
                // params.pidList = topicIdList
                params.lang = this.$i18n.locale
                if ((params.sourceOfInfo && params.sourceOfInfo.length > 0) || params.kpmgInCharge != '' || params.clientInCharge != '') {
                    params.ifSourceInformation = true
                } else {
                    params.ifSourceInformation = false
                }
                const { data, code } = await API.pbc.getPieData(params)

                if (code == '1') {
                    this.dashboardData.pieData = data
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
                this.rsDashboard.disabled = false
            }
        },
        // 查询interim的pbclist
        async getInterimTableData() {
            try {
                this.loading = true

                const { data, code } = await API.pbc.queryInterimPbc({ siteId: this.getSite.siteId })
                if (code == '1') {
                    this.dataPBC = data
                    this.loading = false
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
                this.loading = false
            }
        },
        onChangeRow(row, rowKey) {
            switch (rowKey) {
                case 'confirmDayStamp': {
                    const params = {
                        confirmDayTime: row[rowKey] ? dateFormat(new Date(row[rowKey]), 'yyyy-MM-dd') : null,
                        bindIdList: [row.id],
                        siteId: this.getSite.siteId
                    }
                    this.loading = true
                    API.pbc
                        .updatePbcConfirmDay(params)
                        .then((res) => {
                            if (res && res.code === '1') {
                                this.getTableData()
                                // this.getPieEcharts()
                                // this.getPbcDrawerTable()
                            }
                        })
                        .catch((e) => {
                            console.error(e)
                            this.$message.error(this.$t('SYS_USER_003'))
                        })
                        .finally(() => {
                            this.loading = false
                        })
                    break
                }
                case 'sourceType': {
                    const params = {
                        sourceType: row[rowKey],
                        bindIdList: [row.id],
                        siteId: this.siteId
                    }
                    this.loading = true
                    API.pbc
                        .updatePbcSourceType(params)
                        .then((res) => {
                            if (res && res.code === '1') {
                                this.getTableData()
                                // this.getPieEcharts()
                                // this.getPbcDrawerTable()
                            } else {
                                this.$message.error(this.$(res.code))
                            }
                        })
                        .catch((e) => {
                            console.error(e)
                            this.$message.error(this.$t('SYS_USER_003'))
                        })
                        .finally(() => {
                            this.loading = false
                        })

                    break
                }
                case 'applyFlag': {
                    const params = {
                        applyFlag: row[rowKey],
                        bindIdList: [row.id],
                        siteId: this.siteId
                    }
                    this.loading = true
                    API.pbc
                        .updatePbcApplyFlag(params)
                        .then((res) => {
                            if (res && res.code === '1') {
                                this.getTableData()
                                // this.getPieEcharts()
                                // this.getPbcDrawerTable()
                            } else {
                                this.$message.error(this.$(res.code))
                            }
                        })
                        .catch((e) => {
                            console.error(e)
                            this.$message.error(this.$t('SYS_USER_003'))
                        })
                        .finally(() => {
                            this.loading = false
                        })

                    break
                }
                default:
                    break
            }
        },
        //单个切换topic或者status 的status
        async switchStatus(v, comments) {
            const params = {
                status: v.status,
                bindIdList: [v.id],
                comments: comments,
                siteId: this.getSite.siteId
            }
            try {
                this.loading = true
                const { data, code } = await API.pbc.updateStatus(params)
                if (code == '1') {
                    this.loading = false
                    this.getTableData()
                    // this.getPieEcharts()
                    // this.getPbcDrawerTable()
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
                this.loading = false
            }
        },
        //批量切换status的 status....
        async batchUpdate(v) {
            try {
                const params = {
                    status: v.status,
                    bindIdList: v.chosenList,
                    comments: v.comments,
                    siteId: this.getSite.siteId
                }
                const { data, code } = await API.pbc.updateStatus(params)
                if (code == '1') {
                    this.toogleBatchUPdateVisible()
                    this.onToogleStatus()
                    this.getTableData()
                    // this.getPieEcharts()
                    // this.getPbcDrawerTable()
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
            }
        },
        //导出前弹窗检查
        async clientCheckExportNum() {
            const params = this.getRequestParams()
            params.pagination = null
            const {data, code} = await API.pbc.clientCheckExportNum(params)
            if (code == '1' && data.showFlag == '1') {
                this.$confirm(this.$t('exportPbcListConfirm', {size: data.exportNum}), {
                  confirmButtonText: this.$t('COMMON_EXPORT'),
                  cancelButtonText: this.$t('btn_cancel'),
                  type: 'warning',
                  dangerouslyUseHTMLString: true,
                  cancelButtonClass: 'cancel-btn',
                  confirmButtonClass: 'wl-green',
                  center: false,
                }).then(() => {
                  this.clientExportTableList()
                })
            } else {
                this.clientExportTableList()
            }
        },
        //导出
        async clientExportTableList() {
            const params = this.getRequestParams()
            params.pagination = null
            await downloadFileByUrl(API.pbc.clientExportTableList,params)
        },
        async sysCheckExportNum() {
            const params = this.getRequestParams()
            params.pagination = null
            const {data, code} = await API.pbc.sysCheckExportNum(params)
            if (code == '1' && data.showFlag == '1') {
                this.$confirm(this.$t('exportPbcListConfirm', {size: data.exportNum}), {
                  confirmButtonText: this.$t('COMMON_EXPORT'),
                  cancelButtonText: this.$t('btn_cancel'),
                  type: 'warning',
                  dangerouslyUseHTMLString: true,
                  cancelButtonClass: 'cancel-btn',
                  confirmButtonClass: 'wl-green',
                  center: false,
                }).then(() => {
                  this.exportTableList()
                })
            } else {
                this.exportTableList()
            }
        },
        async exportTableList() {
            const params = this.getRequestParams()
            params.pagination = null
            await downloadFileByUrl(API.pbc.exportTableList,params)
        },
        downloadPBC(v) {
            if (v.length > 0) {
                const list = []
                this.selectedRow = v.map((_v) => {
                    const _parentPbc = this.tableData.find((vv) => {
                        if (vv.childPbcGroup && vv.childPbcGroup.length > 0) {
                            return vv.childPbcGroup.some((vvv) => vvv.id == _v.id)
                        } else {
                            return false
                        }
                    })
                    _v.parentTopicName = _parentPbc && _parentPbc.topicName ? _parentPbc.topicName : ''

                    return _v
                })

                v.forEach((i, n) => {
                    if (i.fileNameList.length > 0) {
                        i.fileNameList.forEach((j, k) => {
                            // downloadable按钮关闭,client端不可以下载非当前客户上传文件
                            if (
                                !(
                                    this.getUser.userType === '2' &&
                                    !this.downloadAble &&
                                    j.uploadBy.indexOf('@') !== -1 &&
                                    j.uploadBy.indexOf(this.curUserName) == -1
                                )
                            ) {
                                list.push({
                                    id: i.id,
                                    fileName: j.name,
                                    fileId: j.fileId,
                                    bindId: i.id,
                                    siteId: this.getSite.siteId,
                                    source: 'pbc'
                                })
                            }
                        })
                    }
                })
                if (list.length === 0) {
                    this.$message.error(this.$t('FILE_LIST_EMPTY_ALERT'))
                    return
                }
                if (list.length === 1) {
                    if (this.downloadDialogMode == 'export') {
                        this.$refs.FileConfirmModal.visible = true
                    } else {
                        this.downloadPBCListSingle(list[0])
                    }
                } else {
                    this.$refs.FileConfirmModal.visible = true
                    // this.downloadPBCList({ list });
                }
            }
        },
        jsonToUrlParam(json) {
            return new URLSearchParams(json).toString()
        },
       
        async downloadPBCListSingle({ bindId, siteId, fileName, fileId, source }) {
            try {
                this.fileDownloading = true
                const downRes = await API.pbc.checkDownloadRight({ bindId, siteId, source })
                if (downRes.code == '1') {
                    const paramsdata = {
                        siteId,
                        id: bindId,
                        tempToken: downRes.data,
                        fileId: fileId,
                        source
                    }
                    downloadSingleFile(paramsdata)
                }
            } catch (e) {
            } finally {
                this.fileDownloading = false
            }
        },
        downloadMultipleFiles(rows) {
            if (this.downloadDialogMode != 'export') {
                if (rows.length === 1) {
                    const { rowId, name, fileId } = rows[0]
                    this.downloadPBCListSingle({ bindId: rowId, siteId: this.getSite.siteId, fileId: fileId, source: 'pbc' })
                } else {
                    let size = 0
                    const list = rows.map((row) => {
                        size += parseInt(row.size || 0)
                        return {
                            // id: row.rowId,
                            // fileName: row.name,
                            bindId: row.rowId,
                            fileId: row.fileId,
                            siteId: this.getSite.siteId,
                            source: 'pbc'
                        }
                    })
                    
                    if (size > windowConfig.download.size) {
                        this.$confirm(
                            this.$t('largeSizeFileAlertContent', { size: formatFileSize(windowConfig.download.size) }),
                            this.$t('largeSizeFileAlertTitle'),
                            {
                                distinguishCancelAndClose: true,
                                showConfirmButton:false,
                                cancelButtonText: this.$t('btn_ok'),
                                cancelButtonClass: 'wl-green',
                            }
                        ).then(() => {
                            this.downloadPBCList({ list },size)
                        })
                    } else {
                        this.downloadPBCList({ list },size)
                    }
                }
            } else if (this.downloadDialogMode == 'export') {
                exportFileLogXls([
                    // 表头
                    [
                        this.$t('serialNo'),
                        this.$t('TABLE_HEADER_topicName'),
                        this.$t('TABLE_HEADER_sub_topicName'),
                        this.$t('PAFE_PBC_LIST_DESC'),
                        this.$t('TABLE_HEADER_entityList'),
                        this.$t('TABLE_HEADER_periodEndDate'),
                        this.$t('DOWNLOAD_FILE_NAME'),
                        this.$t('DOWNLOAD_SIZE'),
                        this.$t('DOWNLOAD_TIME'),
                        this.$t('DOWNLOAD_BY'),
                        this.$t('UPLOAD_TIME'),
                        this.$t('UPLOAD_BY'),
                        this.$t('VERSION_HISTORY')
                    ],
                    ...rows.map((v) => {
                        const _parentPbc = this.tableData.find((vv) => {
                            if (vv.childPbcGroup && vv.childPbcGroup.length > 0) {
                                return vv.childPbcGroup.some((vvv) => vvv.id == v.rowId)
                            } else {
                                return false
                            }
                        })
                        return [
                            v.serialNo ? `${v.serialNo}` : '',
                            _parentPbc && _parentPbc.topicName ? _parentPbc.topicName : v.topicName,
                            v.topicName ? v.topicName : '',
                            v.topicDesc ? v.topicDesc : '',
                            v.entityName ? v.entityName : '',
                            v.periodEndDateStamp ? dateFormat(new Date(v.periodEndDateStamp), 'yyyy-MM-dd') : '',
                            v.name ? v.name : '',
                            v.size ? formatFileSize(v.size) : '0',
                            v.downloadDate ? v.downloadDate : '',
                            v.downloadBy ? v.downloadBy : '',
                            v.uploadDate ? v.uploadDate : '',
                            v.uploadBy ? v.uploadBy : '',
                            v.hasHistory ? v.hasHistory : ''
                        ]
                    })
                ],this.pbcRecordsFileName)
            }
        },
        //批量下载
        async downloadPBCList(params,size) {
            try {
                this.fileDownloading = true
                const downRes = await API.pbc.checkBatchDownloadRight({
                    siteId: this.getSite.siteId,
                    ...params
                })
                if (downRes.code === '1') {
                    const fileIdList = params.list.map((item) => item.fileId).join(',')
                    const reqParams = {
                        token: downRes.data,
                        siteId: this.getSite.siteId,
                        fileIdList
                    }
                    this.$refs.FileConfirmModal.visible = false

                    downloadBatchFiles('/file/free/downloadMultipleFilesAsZip', reqParams,size)
                    
                }
            } catch (e) {
                this.$message.error(e.message)
            } finally {
                this.fileDownloading = false
            }
        },
        downloadFile(resDownload, fileName, callback) {
            let fileReader = new FileReader()
            fileReader.onload = function () {
                try {
                    let jsonData = JSON.parse(this.result)
                    if (jsonData.code) {
                        this.$message.error(this.$t('msg_success'))
                    }
                } catch (err) {
                    const blob = new Blob([resDownload])
                    if (isIE()) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = window.URL.createObjectURL(blob)
                        link.setAttribute('download', fileName)
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                    }
                } finally {
                    callback()
                }
            }
            fileReader.readAsText(resDownload)
        },
        async copyFromInterim(v) {
            try {
                const params = {
                    siteId: this.getSite.siteId,
                    pbcGroupIdList: v
                }
                const { data, code } = await API.pbc.copyFromInterim(params)

                if (code == '1') {
                    this.$message.success(this.$t('msg_success'))
                    this.updateTableStatusInterim()
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
            }
        },
        onToogleStatus() {
            this.updateTableStatus('setStatus')
        },
        onToogleDownLoad(mode) {
            this.downloadDialogMode = mode
            this.updateTableStatus(mode)
        },
        onToogleSendEmail() {
            this.updateTableStatus('sendEmail')
        },
        onToogleCopy() {
            this.tableData = []
            this.updateTableStatus('copy')
            this.getInterimTableData()
        },
        async updateTableStatusInterim() {
            this.tableData = []
            await this.queryTopicList()
            this.updateTableStatus()
            this.getTableData()
            // this.getPieEcharts()
            // this.getPbcDrawerTable()
        },
        onPaginationChange(v, s = 10) {
            this.pagination.pageNum = v
            this.pagination.pageSize = s
            this.getTableData()
            // this.getPieEcharts()
            // this.getPbcDrawerTable()
        },
        toogleBatchUPdateVisible() {
            this.batchUPdateVisible = !this.batchUPdateVisible
        },
        openChangeVisiblePop(v) {
            this.toogleBatchUPdateVisible()
            this.chosen = v
        },
        getRequestParams() {
            let startDaysUntilDue
            let endDaysUntilDue
            let startDayOverDue
            let endDayOverDue
            if (this.status.includes('5')) {
                startDaysUntilDue = this.dayOverDue && this.dayOverDue[0] ? this.dayOverDue[0] : 0
                endDaysUntilDue = this.dayOverDue && this.dayOverDue[1] ? this.dayOverDue[1] : 10000
            } else {
                startDaysUntilDue = ''
                endDaysUntilDue = ''
            }
            if (this.status.includes('6')) {
                startDayOverDue = this.daysUntilDue && this.daysUntilDue[0] ? this.daysUntilDue[0] : 0
                endDayOverDue = this.daysUntilDue && this.daysUntilDue[1] ? this.daysUntilDue[1] : 10000
            } else {
                startDayOverDue = ''
                endDayOverDue = ''
            }

            const params = {
                //  this.getEntityIds.length === this.allEntityIds.length 表示全选，传一个tag
                entityId: this.getEntityIds.length === this.allEntityIds.length ? null : this.getEntityIds,
                siteId: this.siteId,
                auditType: this.active,
                statusList: this.status,
                topicIdList: this.topic || [],
                descTopicIdList: this.topicDes || [],
                startDayOverDue,
                endDayOverDue,
                startDaysUntilDue,
                endDaysUntilDue,
                startUploadTime: this.uploadTime && this.uploadTime[0] ? dateFormat(new Date(this.uploadTime[0]), 'yyyy-MM-dd') : '',
                endUploadTime: this.uploadTime && this.uploadTime[1] ? dateFormat(new Date(this.uploadTime[1]), 'yyyy-MM-dd') : '',

                startDueDay: this.dueTime && this.dueTime[0] ? dateFormat(new Date(this.dueTime[0]), 'yyyy-MM-dd') : '',
                endDueDay: this.dueTime && this.dueTime[1] ? dateFormat(new Date(this.dueTime[1]), 'yyyy-MM-dd') : '',
                startPeriodEndDate:
                    this.periodEndDate && this.periodEndDate[0] ? dateFormat(new Date(this.periodEndDate[0]), 'yyyy-MM-dd') : '',
                endPeriodEndDate:
                    this.periodEndDate && this.periodEndDate[1] ? dateFormat(new Date(this.periodEndDate[1]), 'yyyy-MM-dd') : '',
                sourceOfInfo: this.sourceOfInfo,
                applyFlagInfo: this.applyFlagInfo,
                kpmgInCharge: this.kpmgResponsible || '',
                clientInCharge: this.clientResponsible || '',
                ...this.pagination,
                startCreateDate: this.createDate && this.createDate[0] ? dateFormat(new Date(this.createDate[0]), 'yyyy-MM-dd') : '',
                endCreateDate: this.createDate && this.createDate[1] ? dateFormat(new Date(this.createDate[1]), 'yyyy-MM-dd') : '',
                lastedUploadUserAccount: this.lastedUploadUserAccount,
                startClientConfirmDateStr:
                    this.clientConfirmDate && this.clientConfirmDate[0]
                        ? dateFormat(new Date(this.clientConfirmDate[0]), 'yyyy-MM-dd')
                        : '',
                endClientConfirmDateStr:
                    this.clientConfirmDate && this.clientConfirmDate[1] ? dateFormat(new Date(this.clientConfirmDate[1]), 'yyyy-MM-dd') : '',
                startCommentDate: this.commentDate && this.commentDate[0] ? dateFormat(new Date(this.commentDate[0]), 'yyyy-MM-dd') : '',
                endCommentDate: this.commentDate && this.commentDate[1] ? dateFormat(new Date(this.commentDate[1]), 'yyyy-MM-dd') : '',
            }
            if (this.submitted_before_deadline_pbc_request) {
                params.statusList = [2, 4, 5]
            }
            if (this.overdued_pbc_count) {
                params.statusList = [2, 4, 6]
            }
            if (this.serialNo) {
                params.serialNo = this.serialNo
            }
            if (this.fileName) {
                params.fileName = this.fileName
            }
            this.prevParams = params

            //  
            return params
        },
        updateTableStatus(mode = '') {
            this.tableStatus = { editable: !this.tableStatus.editable, mode }
        },
        btnCancel(mode = '') {
            this.downloadDialogMode = mode
            this.tableStatus = { editable: !this.tableStatus.editable, mode }
        },
        async selectKPOwner() {
            try {
                const { data, code } = await API.matterLogs.searchKpmgOwner({ siteId: this.siteId, searchContent: '' })
                if (code == '1') {
                    this.kpmgOwnerList = data
                    this.kpmgOwnerList.map((item) => {
                        if (item.userName === 'Blank') {
                            item.userName = this.$t('common_empty')
                            item.profitCenter = this.$t('common_empty')
                        }
                    })
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
            }
        },
        async selectClientOwner() {
            try {
                const { data, code } = await API.matterLogs.searchClientOwner({
                    siteId: this.siteId,
                    searchContent: ''
                })
                if (code == '1') {
                    this.clientOwnerList = data
                    this.clientOwnerList.map((item) => {
                        if (item.userName === 'Blank') {
                            item.userName = this.$t('common_empty')
                            item.email = this.$t('common_empty')
                        }
                    })
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
            }
        },
        onDuedayChange(params) {
            this.loading = true
            API.pbc.changePbcDueDay({ siteId: this.getSite.siteId, ...params }).then((res) => {
                this.loading = false
                res.data && this.getTableData()
                // this.getPieEcharts()
                // this.getPbcDrawerTable()
            })
        },
        onConfirmDayChange(params) {
            this.loading = true
            API.pbc.updatePbcConfirmDay({ siteId: this.getSite.siteId, ...params }).then((res) => {
                this.loading = false
                res.data && this.getTableData()
                // this.getPieEcharts()
                // this.getPbcDrawerTable()
            })
        },
        onChargeUserChange(params) {
            this.loading = true
            API.pbc.updatePersonInCharge(params).then((res) => {
                this.loading = false
                res.data && this.getTableData()
                // this.getPieEcharts()
                // this.getPbcDrawerTable()
            })
        },
        tableDataToLevel3(tableData) {
            if (!tableData) tableData = []
            return tableData.map((v) => {
                const total = [v.due - 0, v.overdue - 0, v.uploaded - 0, v.revisionRequired - 0, v.accepted - 0].reduce(
                    (pre, v, k, arr) => {
                        pre += v
                        return pre
                    },
                    0
                )
                const value21 = v.beforeDeadline - 0
                const value22 = v.afterDeadline - 0
                const value23 = v.afterDeadline == 0 ? 0 : Math.round(v.totalOverdueDays / v.afterDeadline)
                const value24 = v.uploadToRevisionTotalTimes - 0
                const percent21 = total == 0 ? 0 : Math.round((value21 / total) * 100)
                const percent22 = total == 0 ? 0 : Math.round((value22 / total) * 100)
                const percent24 = total == 0 ? 0 : Math.round((value24 / total) * 100)
                return {
                    ...v,
                    value21,
                    value22,
                    value23,
                    value24,
                    percent21,
                    percent22,
                    percent24
                }
            })
        },
        makeRsDashboardData(dashboardData) {
            const total = [
                dashboardData.pieData.due - 0,
                dashboardData.pieData.overdue - 0,
                dashboardData.pieData.uploaded - 0,
                dashboardData.pieData.revisionRequired - 0,
                dashboardData.pieData.accepted - 0
            ].reduce((pre, v, k, arr) => {
                pre += v
                return pre
            }, 0)
            const value11 = [
                dashboardData.pieData.due - 0,
                dashboardData.pieData.overdue - 0,
                dashboardData.pieData.revisionRequired - 0
            ].reduce((pre, v, k, arr) => {
                pre += v
                return pre
            }, 0)
            const value12 = dashboardData.pieData.uploaded - 0
            const value13 = dashboardData.pieData.accepted - 0
            const value21 = dashboardData.pieData.beforeDeadline - 0
            const value22 = dashboardData.pieData.afterDeadline - 0
            const value23 =
                dashboardData.pieData.afterDeadline == 0
                    ? 0
                    : Math.round(dashboardData.pieData.totalOverdueDays / dashboardData.pieData.afterDeadline)
            const value24 = dashboardData.pieData.uploadToRevisionTotalTimes - 0
            return {
                pbcTotal: total,
                level1: [
                    {
                        title: this.$t('outstanding_PBC_requests_count'),
                        count: value11,
                        percent: total == 0 ? 0 : Math.round((value11 / total) * 100),
                        colorDirection: 2
                    },
                    {
                        title: this.$t('client_submitted_but_pending_KPMG_confirmation_PBC_requests_count'),
                        count: value12,
                        percent: total == 0 ? 0 : Math.round((value12 / total) * 100),
                        // value12 和 13 需要一个给进度条的百分比，是这两个数共同构成100%
                        percent_display: total == 0 ? 0 : Math.round((value12 / (value13 + value12)) * 100),
                        colorDirection: 2,
                        tip: this.$t('client_submitted_but_pending_KPMG_confirmation_PBC_requests_count_tip')
                    },
                    {
                        title: this.$t('KPMG_accepted_PBC_requests'),
                        count: value13,
                        percent: total == 0 ? 0 : Math.round((value13 / total) * 100),
                        percent_display: total == 0 ? 0 : Math.round((value13 / (value13 + value12)) * 100),
                        colorDirection: 1,
                        tip: this.$t('KPMG_accepted_PBC_requests_tip')
                    }
                ],
                level2: [
                    {
                        title: this.$t('submitted_before_deadline_pbc_request'),
                        count: value21,
                        percent: total == 0 ? 0 : Math.round((value21 / total) * 100),
                        colorDirection: 1,
                        tip: this.$t('submitted_before_deadline_pbc_request_tip')
                    },
                    {
                        title: this.$t('overdued_pbc_count'),
                        count: value22,
                        percent: total == 0 ? 0 : Math.round((value22 / total) * 100),
                        colorDirection: 2,
                        tip: this.$t('overdued_pbc_count_tip')
                    },
                    {
                        title: this.$t('overdued_on_average'),
                        count: value23,
                        percent: 100,
                        colorDirection: 1,
                        hidePercent: true,
                        tip: ''
                    },
                    {
                        title: this.$t('revision_required_count'),
                        count: value24,
                        percent: total == 0 ? 0 : Math.round((value24 / total) * 100),
                        colorDirection: 2,
                        tip: ''
                    }
                ],
                level3: this.tableDataToLevel3(dashboardData.tableData)
            }
        },
        nextClick() {
            this.updateGuideStep = 2
        },
        gotItClick() {
            let param = {
                pbcNoticeReadFlag: 1
            }
            API.common.updateBehavior(param).then((res) => {
                if (res.code === '1') {
                    this.updateGuide = false
                    this.updateGuideStep = 0
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        getBehavior() {
            API.common.queryBehavior().then((res) => {
                if (res.code === '1') {
                    this.updateGuide = res.data.pbcNoticeReadFlag === 0
                    this.updateGuideStep = 1
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        openEntity() {
            this.$refs.entity.updateDrawer()
        }
    },
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser',
            getEntityIds: 'getEntityIds',
            getSite: 'getSite',
            getIfKpHasAccess: 'getIfKpHasAccess',
        }),
        pbcRecordsFileName(){
            return `PBC_${this.active === '1'?'interim':'final'}_files records@${dateFormat(new Date(),'yyyyMMdd')}.xlsx`
        },
        entityDataTotalSize(){
            const flatTree = treeToList(this.entityData).filter(item=>!item.disabled)
            return flatTree.length
        },
        // 会计科目表头下拉选项内容
        topicList() {
            const { topicListFilterText } = this
            let res = []
            let selectAll = [
                {
                    topicBindId: null,
                    topicDesc: '[ ' + this.$t('FILE_SELECT_ALL') + ' ]',
                    topicId: 'select_all',
                    topicName: '[ ' + this.$t('FILE_SELECT_ALL') + ' ]'
                }
            ]
            if (!topicListFilterText) {
                res = this.baseTopicList
            } else {
                res = this.baseTopicList.filter((x) => (x.topicName || '').toLowerCase().includes(topicListFilterText.toLowerCase()))
                res = [...selectAll, ...res]
            }

            const x = res.map((v) => {
                if (v.topicDesc === 'Blank') {
                    v.topicDesc = this.$t('common_empty')
                    v.topicName = this.$t('common_empty')
                }
                if (v.topicSrc == 2 && v.topicDesc && v.topicName.indexOf(`(${v.topicDesc})`) == -1) {
                    v.topicName = `${v.topicName}(${v.topicDesc})`
                }
                return v
            })

            return x
        },
        // 已识别的相关数据要素
        topicDesList() {
            const { topicDesFilterText } = this
            let temp =
                this.topic && this.topic.length > 0
                    ? this.baseTopicList.filter((item) => this.topic.includes(item.topicId))
                    : this.baseTopicList
            temp.map((item) => {
                if (item.topicDesc === 'Blank') {
                    item.topicDesc = this.$t('common_empty')
                }
            })
            if (!topicDesFilterText) return temp.filter((topic) => topic.topicDesc != null && topic.topicDesc != '')
            let selectAll = [
                {
                    topicBindId: null,
                    topicDesc: '[ ' + this.$t('FILE_SELECT_ALL') + ' ]',
                    topicId: 'select_all',
                    topicName: '[ ' + this.$t('FILE_SELECT_ALL') + ' ]'
                }
            ]
            let filterRes = temp.filter((x) => (x.topicDesc || '').toLowerCase().includes(topicDesFilterText.toLowerCase()))
            return filterRes.length > 0 ? selectAll.concat(filterRes) : filterRes
        },
        statusList2Change() {
            return _.filter(this.statusList, (v) => v.value !== '1' && v.value !== '3')
        },
        filterStatusList() {
            return this.statusList.filter((item) => item.value !== '1').sort((a, b) => a.value - 0 - (b.value - 0))
        },
        rsDashboardData() {
            return this.makeRsDashboardData(this.dashboardData)
        },
        clearAllActive() {
            return (
                (this.status && this.status.length > 0) ||
                (this.dayOverDue && this.dayOverDue.length > 0 && this.dayOverDue.every((v) => !!v)) ||
                (this.daysUntilDue && this.daysUntilDue.length > 0 && this.daysUntilDue.every((v) => !!v)) ||
                (this.topic && this.topic.length > 0) ||
                (this.topicDes && this.topicDes.length > 0) ||
                (this.uploadTime && this.uploadTime.length > 0) ||
                (this.dueTime && this.dueTime.length > 0) ||
                (this.periodEndDate && this.periodEndDate.length > 0) ||
                (this.sourceOfInfo && this.sourceOfInfo.length > 0) ||
                (this.applyFlagInfo && this.applyFlagInfo.length > 0) ||
                (this.kpmgResponsible && this.kpmgResponsible.length > 0) ||
                (this.clientResponsible && this.clientResponsible.length > 0) ||
                (this.createDate && this.createDate.length > 0) ||
                (this.lastedUploadUserAccount && this.lastedUploadUserAccount.length > 0) ||
                (this.clientConfirmDate && this.clientConfirmDate.length > 0 && this.clientConfirmDate.every((v) => !!v)) ||
                this.fileName != '' ||
                this.serialNo != ''||
                (this.getEntityIds.length!==this.entityDataTotalSize)||
                (this.commentDate && this.commentDate.length > 0) 
            )
        },
        messageType() {
            return this.active
        },
        siteId() {
            return this.$route.query.siteId ? this.$route.query.siteId : this.getSite.siteId
        }
    },
    components: {
        FileConfirmModal,
        SelectMulti,
        PbcTable,
        BatchUpdate,
        Entity,
        dashboard,
        RsDashboard,
        TableColumnsControl,
        GuidanceTooltip,
        NewComments
    }
}
</script>

<style scoped>
.updateGuide {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000;
    z-index: 100;
}
::v-deep .el-loading-mask {
    z-index: 9 !important;
}
.wl-container {
    color: #444;
    height: 100%;
    background: #eff1f5;
    padding: 22px;
}
.wl-content-container {
    height: 100%;
    background: #fff;
    padding: 10px 22px;
    border-radius: 8px;
    position: relative;
}
.top-right-btns {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.top-right-btns .table-column-config {
    line-height: 30px;
    cursor: pointer;
    font-size: 21px;
}
.top-right-btns .split {
    width: 1px;
    height: 14px;
    border-left: solid 1px #ccced2;
    margin: 0 15px;
}
.top-right-btns .clean-filter {
    font-size: 12PX;
    line-height: 30px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: black;
}
.top-right-btns .clean-filter:hover {
    color: #005eb8;
}

.top-right-btns .clean-filter img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
}

.tab-box {
    height: 30PX;
    display: flex;
    justify-content: space-between;
}
.wl-tab {
    display: flex;
    list-style: none;
    justify-content: flex-start;
    align-items: flex-start;
}
.wl-tab li {
    margin-right: 10px;
    background-color: #ccced2;
    height: 28PX;
    line-height: 28PX;
    border-radius: 14PX;
    color: #fff;
    font-size: 14PX;
    padding: 0 30px;
    cursor: pointer;
}
.wl-tab li.active {
    background-color: #3879eb;
}
::v-deep .el-collapse-item__content {
    padding-bottom: 0;
}
::v-deep .el-collapse-item__header {
    height: 35px;
    line-height: 35px;
}
.search-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
}
.search-btn-row {
    height: 40PX;
    padding-top: 10PX;
}

.wl-pbc-table {
    height: calc(100% - 10PX - 70PX);
    transition: height 0.4s;
    margin-top: 10PX;
}
.show-search {
    height: calc(100% - 66px - 168PX);
}
.show-search-rows4 {
    height: calc(100% - 76px - 198PX);
}
.wl-item {
    margin-right: 12px;
    max-width: 370PX;
    min-width: 150PX;
}
.topic-item-cls {
    width: 253px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.dayDueInput {
    width: 80PX;
}
.sourceOfInfo-select-cls {
    width: 255PX;
    margin-right: 10px;
}
.input-with-select {
    margin-top: 5px;
    margin-bottom: 5px;
}
.input-with-select ::v-deep .el-input,
.input-with-select ::v-deep .el-input .el-input__inner {
    height: 30PX !important;
    line-height: 30PX;
    font-size: 12PX;
}
.responsible-select-cls {
    width: 255PX;
    margin-right: 10px;
}

.wl-status-item,
.wl-date-item {
    width: 300PX !important;
}
.wl-date-item2 {
    width: 370PX !important;
}
::v-deep .wl-date-item.el-date-editor .el-range-input,
::v-deep .wl-date-item2.el-date-editor .el-range-input {
    width: 45%;
}
.wl-topic-item1 {
    width: 16%;
    max-width: 400px;
}
.wl-topic-item2 {
    width: 19%;
    max-width: 400px;
}
.right {
    float: right;
}

.margin {
    margin-right: 10px;
}
.search-control {
    font-size: 15px;
    margin: 10px 0;
}
.search-control:hover {
    cursor: pointer;
}
.search-collapse {
    height: 180px;
    transition: all linear 0.1s;
}
.el-input__inner input[type='number']::-webkit-outer-spin-button,
.el-input__inner input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
}
/*在firefox下移除input[number]的上下箭头*/
.el-input__inner input[type='number'] {
    -moz-appearance: textfield;
}
.column-btn {
    font-size: 12PX;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.column-btn-active .table-setting-text {
    font-weight: 600;
    color: #5879eb;
}
.column-btn .table-setting-icon {
    width: 20px;
    margin-right: 5px;
}
.column-btn:hover {
    color: rgb(0, 94, 184);
}
.rsdashboard-filter-tag {
    height: 30PX;
    line-height: 30PX;
    background-color: #3879eb;
    color: white;
    border-radius: 5px;
    margin-left: 10px;
    padding: 0 10px;
}
.rsdashboard-filter-tag i {
    padding: 1px;
    text-align: center;
    border-radius: 50%;
}
.rsdashboard-filter-tag i:hover {
    cursor: pointer;
    background-color: #1651b9;
}
::v-deep .el-tag {
    display: flex;
    flex-direction: row;
    align-items: center;
}
::v-deep .el-select__tags-text {
    display: inline-block;
    max-width: 68px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.updateGuideIcon {
    height: 24PX;
    width: 24PX;
    z-index: 101;
    border: 2PX solid #3879eb !important;
    border-radius: 10px;
    position: relative;
}
.updateGuideIcon .updateGuideTip {
    z-index: 101;
    background-color: #3879eb;
    padding: 20px;
    color: white;
    position: absolute;
    right: 0;
    top: 26PX;
    width: 240PX;
    border-radius: 10px;
    font-size: 14PX;
    line-height: normal;
}
.margin-bottom-10 {
    margin-bottom: 10PX;
}
.guide-btn {
    float: right;
    color: #3879eb;
}
</style>
